<template>
  <svg
    @click="$store.commit('stopTick')"
    class="pauseIcon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM8.33333 8.77778C8.33333 8.22549 8.78105 7.77778 9.33333 7.77778H10C10.5523 7.77778 11 8.22549 11 8.77778V15C11 15.5523 10.5523 16 10 16H9.33333C8.78105 16 8.33333 15.5523 8.33333 15V8.77778ZM13.7778 7.77778C13.2255 7.77778 12.7778 8.22549 12.7778 8.77778V15C12.7778 15.5523 13.2255 16 13.7778 16H14.4444C14.9967 16 15.4444 15.5523 15.4444 15V8.77778C15.4444 8.22549 14.9967 7.77778 14.4444 7.77778H13.7778Z"
      :fill="color"
    />
  </svg>

  <teleport to="#app">
    <transition name="fade">
      <GamePause v-if="showPause" />
    </transition>
  </teleport>
</template>

<script>
import GamePause from "@/components/GamePause.vue";

export default {
  name: "pause",
  props: { color: String },
  components: { GamePause },
  computed: {
    showPause: function() {
      return this.$store.state.gamePause;
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.pauseIcon {
  position: absolute;
  top: 8px;
  left: 8px;
  width: 24px;
  height: 24px;
  opacity: 0.65;
}
</style>
